module.exports = __webpack_public_path__ + "img/gongyi001.0eb80475.png";